import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import axiosRetry from "axios-retry"

// const API_URL = "http://157.175.47.65:4000/api/v1/"
const API_URL = "https://halfm-api.applligentdemo.com/api/v1/"
export const DOMAIN_URL = "https://dev-api.halfm.sa"
const axiosApi = axios.create({
  baseURL: API_URL,
})

axiosApi.interceptors.request.use(
  async config => {
    const token = await accessToken()
    if (token) {
      config.headers.Authorization = token
    }

    const language =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("I18N_LANGUAGE")
        : null
    config.headers["Accept-Language"] = language === "sa" ? "ar" : "en"

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

axiosApi.interceptors.request.use(
  async config => {
    const token = await accessToken()
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Applying axios-retry to your axios instance
axiosRetry(axiosApi, {
  retries: 3, // Number of retries
  retryDelay: retryCount => {
    return retryCount * 1000 // Time between retries in ms
  },
  retryCondition: error => {
    // Retry on specific conditions
    return error.response.status === 500 || error.code === "ECONNABORTED"
  },
})

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data
      }
    })
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, data, config = {}) {
  return await axiosApi
    .delete(url, { data: { ...data }, ...config })
    .then(response => response.data)
}

export async function patch(url, config = {}) {
  return await axiosApi
    .patch(url, { ...config })
    .then(response => response.data)
}

export async function formDataPost(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config }) // Directly pass the FormData object
    .then(response => response.data)
}

export async function formDataPut(url, data, config = {}) {
  return axiosApi
    .put(url, data, { ...config }) // Directly pass the FormData object
    .then(response => response.data)
}

export async function pdfDownload(url, data, config) {
  return axiosApi
    .post(url, data, { ...config, responseType: "blob" }) // Directly pass the FormData object
    .then(response => response.data)
}
